import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { useAuthStore } from './store/useAuthStore';
import { authService } from './services/api';
import AppLayout from './layout/AppLayout';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import AddProtest from './pages/AddProtest';
import AddProtestManual from './pages/AddProtestManual';
import Admin from './pages/Admin';
import StatisticsDashboard from './pages/StatisticsDashboard';
import ProtestDetail from './pages/ProtestDetail';
import Trash from './pages/Trash';
import Reports from './pages/Reports';
import CreateReportPage from './pages/CreateReportPage';
import ReportViewPage from './pages/ReportViewPage';
import Settings from './pages/Settings';

function ProtectedRoute({ children, roles }) {
    const { token, user } = useAuthStore();
    if (!token) return <Navigate to="/login" />;
    if (roles && user && !roles.includes(user.role)) return <Navigate to="/protests" />;
    return children;
}

function AppRoute({ children, roles }) {
    return (
        <ProtectedRoute roles={roles}>
            <AppLayout>{children}</AppLayout>
        </ProtectedRoute>
    );
}

export default function App() {
    const { token, setUser } = useAuthStore();

    useEffect(() => {
        if (token) {
            authService.me()
                .then((res) => setUser(res.data))
                .catch(() => {});
        }
    }, [token, setUser]);

    return (
        <BrowserRouter>
            <Routes>
                <Route path="/login" element={<Login />} />

                <Route path="/protests" element={
                    <AppRoute><Dashboard /></AppRoute>
                } />
                <Route path="/protests/:id" element={
                    <AppRoute><ProtestDetail /></AppRoute>
                } />
                <Route path="/add-protest" element={
                    <AppRoute roles={['free_user', 'region_admin', 'super_admin']}>
                        <AddProtest />
                    </AppRoute>
                } />
                <Route path="/add-protest-manual" element={
                    <AppRoute roles={['free_user', 'super_admin']}>
                        <AddProtestManual />
                    </AppRoute>
                } />
                <Route path="/admin" element={
                    <AppRoute roles={['super_admin']}><Admin /></AppRoute>
                } />
                <Route path="/stats" element={
                    <AppRoute roles={['super_admin']}><StatisticsDashboard /></AppRoute>
                } />
                <Route path="/reports" element={
                    <AppRoute roles={['free_user', 'super_admin']}><Reports /></AppRoute>
                } />
                <Route path="/reports/create" element={
                    <AppRoute roles={['free_user', 'super_admin']}><CreateReportPage /></AppRoute>
                } />
                <Route path="/reports/:id" element={
                    <AppRoute roles={['free_user', 'super_admin']}><ReportViewPage /></AppRoute>
                } />
                <Route path="/trash" element={
                    <AppRoute roles={['super_admin']}><Trash /></AppRoute>
                } />
                <Route path="/settings" element={
                    <AppRoute><Settings /></AppRoute>
                } />

                {/* backward-compat redirects */}
                <Route path="/dashboard" element={<Navigate to="/protests" replace />} />
                <Route path="/add" element={<Navigate to="/add-protest" replace />} />

                <Route path="/" element={
                    <Navigate to={token ? '/protests' : '/login'} replace />
                } />
            </Routes>
        </BrowserRouter>
    );
}
